module.exports = __webpack_public_path__ + "static/media/rectangle.4ef81859.svg";